export const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000/api';
console.log(process.env)
console.log("API_URL", API_URL);
export const USER_PERMISSIONS = {
  CAN_ADD_SHOP: 'mrapi.add_shop',
  CAN_SHARE_SHOP: 'mrapi.share_shop',
  CAN_VIEW_SHOP_USERS: 'mrapi.view_shop_users',
  CAN_CHANGE_SHOP_USER: 'mrapi.change_shop_user',

}
export const API_PATH = {
  ALL_MODELS: `${API_URL}/getAlldevBrndModel`,
  SEARCH: `${API_URL}/searchshop`,
  NEXT_SLOTS: `${API_URL}/searchShopNextslots`,
  SHOP_DEVICES: `${API_URL}/searchShopDevices`,
  CONTACTUS: `${API_URL}/contact-us`,
  SUBSCRIBE: `${API_URL}/blog-subscription`,
  GETFILTERFIELDS: `${API_URL}/getfilterfields`,
  GETFILTERFIELDEXT: `${API_URL}/getfilterfieldext`,
  REGISTERUSER: `${API_URL}/signup`,
  GETAUTHUSER: `${API_URL}/auth-user`,
  GETUSERSHOPS: `${API_URL}/get-shops`,
  GETSHOPUSERS: `${API_URL}/get-shop-users`,
  GETSHOPINVITATIONDETAILS: `${API_URL}/get-shop-invitation-details`,
  CONFIRMSHOPINVITATION: `${API_URL}/confirm-shop-invitation`,
  REMOVESHOPPERMISSIONS: `${API_URL}/remove-shop-permissions`,
  LOGIN: `${API_URL}/rest-auth/login`,
  LOGINASUSER: `${API_URL}/admin/login-as-user`,
  LOGOUT: `${API_URL}/logout`,
  OBTAINAUTHTOKEN: `${API_URL}/token`,
  ACCOUNTSETTING: `${API_URL}/account-settings`,
  ADD_SHOP: `${API_URL}/add-shop`,
  UPDATEACCOUNT: `${API_URL}/auth-users`,
  UPDATEACCOUNTLOCATION: `${API_URL}/update-account-geolocation`,
  RESETPASSWORDCONFIRM: `${API_URL}/reset-password-confirm`,
  UPDATEACCOUNTPROFILE: `${API_URL}/update-account-profile`,
  UPDATEACCOUNTDETAIL: `${API_URL}/update-account-detail`,
  UPDATEVALIDOPENTIME: `${API_URL}/update-valid-open-time`,
  UPDATEINVALIDOPENTIME: `${API_URL}/update-invalid-open-time`,
  GETVALIDOPENTIME: `${API_URL}/get-valid-open-time`,
  GETINVALIDOPENTIME: `${API_URL}/get-invalid-open-time`,
  REPAIRDEVICES: `${API_URL}/repair-devices`,
  DELETEREPAIRDEVICE: `${API_URL}/delete-repair-device`,
  GETREVIEWS: `${API_URL}/get-reviews`,
  GETMODELSERVICE: `${API_URL}/get-model-service`,
  GETDEVICES: `${API_URL}/get-devices`,
  GETBRANDS: `${API_URL}/get-brands`,
  GETSERIES: `${API_URL}/get-series`,
  GETMODELS: `${API_URL}/get-models`,
  GETREPARATIONS: `${API_URL}/get-reparations`,
  GETAPPOINTMENTNUMBER: `${API_URL}/get_appointment_number`,
  GETAPPOINTMENTTIMETABLE: `${API_URL}/get_appointment_timetable`,
  CREATEAPPOINTMENT: `${API_URL}/create-appointment`,
  CREATESHOPREPAIRSERVICE: `${API_URL}/create-shop-repair-service`,
  REPAIRBRANDMODEL: `${API_URL}/repair-brand-model`,
  GETSHOPREPAIRATION: `${API_URL}/get-shop-reparation`,
  VERIFYACCOUNT: `${API_URL}/activate`,
  SHOPGUARANTEE: `${API_URL}/shop-guarantee-reparation`,
  GUARANTEEMODELS: `${API_URL}/shop-guarantee-reparation`,
  GETAPPOINTMENTS: `${API_URL}/get-appointments`,
  GETSINGLEAPPOINTMENT: `${API_URL}/get-appointment`,
  UPDATEAPPOINTMENT: `${API_URL}/update-appointment`,
  CANCELAPPOINTMENT: `${API_URL}/cancel-appointment`,
  FILTERREPARATION: `${API_URL}/filter-appointment`,
  APPOINTMENTEMAIL: `${API_URL}/appointment-emails`,
  REPAIRCOLSEAUTUEMAIL: `${API_URL}/repair-close-auto-email`,
  CHECKREVIEWPAGE: `${API_URL}/check-review-page`,
  CREATEREVIEW: `${API_URL}/create-review`,
  EVALUATERATE: `${API_URL}/evaluate-shop-rate`,
  GETNEWESTSHOPS: `${API_URL}/get-newest-shops`,
  UPLOADIMAGE: `${API_URL}/upload-image`,
  UPLOAD_APPOINTMENT_IMAGE: `${API_URL}/shop-images/`,
  UPLOADLOGOIMAGE: `${API_URL}/logo-image`,
  GETREPARATIONGUARANTEE: `${API_URL}/get-reparation-guarantee`,
  DELETEGUARANTEEMODELS: `${API_URL}/delete-guarantee-model`,
  RESETPASSWORDEMAIL: `${API_URL}/password/reset`,
  RESETPASSWORDCONFIRMEMAIL: `${API_URL}/password/reset-confirm`,
  GETSHOPIDBYINFORMATION: `${API_URL}/get-shopid-by`,
  EXPORTCSV: `${API_URL}/export-csv/`,
  IMPORTCSV: `${API_URL}/import-csv/`,
  GETSHOPPUBLISHPROFILE: `${API_URL}/get-shops-publish-profile/`,
  GETSHOPDEVICES: `${API_URL}/get-shop-devices`,
  GETDEVICEBRANDS: `${API_URL}/get-shop-brands`,
  GETBRANDMODELS: `${API_URL}/get-shop-models`,
  GETBRANDSERIES: `${API_URL}/get-shop-series`,
  GETSHOPREPARATIONDETAILS: `${API_URL}/get-shop-reparations`,
  GETREPARATIONDETAILS: `${API_URL}/get-shop-reparation-detail`,
  SAVESHOPREPARATION: `${API_URL}/save-shop-reparation`,
  UPDATESHOPREPARATION: `${API_URL}/update-shop-reparation`,
  CREATEAPPOINTMENTMANUALLY: `${API_URL}/shop-create-appointment`,
  GETPAGES: `${API_URL}/get-pages`,
  GETPAGEDETAILS: `${API_URL}/pagedetail`,
  GETMODELDETAILS: `${API_URL}/get-model-detail`,
  GETMODELREPARATIONS: `${API_URL}/get-model-repairs`,
  GETALLBRANDSMODELS: `${API_URL}/get-brandmodel`,
  GETALLNOTIFICATIONS: `${API_URL}/get-notification`,
  GETDASHSTATS: `${API_URL}/get-appointment-stats`,
  GETSHOPGENERALINFO: `${API_URL}/getshopGeneralInfo`,
  GETSHOPGENERALINFODETAIL: `${API_URL}/getshopGeneralInfoDetail`,
  GETACTIVEBRANDS: `${API_URL}/get-active-brands`,
  GETPURCAHSES: `${API_URL}/get-purchases`,
  UPDATESHOPGENERALINFO: `${API_URL}/update-shop-info`,
  SAVEINVALIDTIME: `${API_URL}/save-invalid-time`,
  GETINVALIDTIME: `${API_URL}/get-shop-invalid-time`,
  DELETEINVALIDTIME: `${API_URL}/delete-invalid-time`,
  PAYMENT: `${API_URL}/payment/`,
  GETPAYMENT: (id) => `${API_URL}/payment-status/${id}/`,
  SHOPINVITEUSER: `${API_URL}/shop-invite-user`,

};

export default {
  API_URL,
  API_PATH,
};
